import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Branch} from './branch';

@Injectable()
export class BranchService {

  constructor(private http: Http) {

  }

  getAll(page: number = 1, sort: string = '') {
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if(!currentfilter) {
      currentfilter = {};
    }

    const params = new URLSearchParams();
    params.set('page',  page+'');
    params.set('sorts', sort);
    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }
    return this.http.get('branches?' + params.toString()).map((response: Response) => response.json());
  }

  getById(_id: string) {
    return this.http.get('branches/' + _id).map((response: Response) => response.json());
  }

  getAllBranches() {
    return this.http.get('branches/all').map((response: Response) => response.json());
  }
  
  getAllDepartments() {
    return this.http.get('departments/all').map((response: Response) => response.json());
  }

  getAllDepartmentsexep(_id: string,_branch: string) {
    return this.http.get('departments/allex/'+ _id + '/' + _branch ).map((response: Response) => response.json());
  }

  getBranches() {
    return this.http.get('branches_settings/custom').map((response: Response) => response.json());
  }

  getUserBranches() {
      return this.http.get('branches/userbranches').map((response: Response) => response.json());
  }

  getBranchUsers(_id: string) {
      return this.http.get('branch/' + _id + '/users').map((response: Response) => response.json());
  }

  getTrashedById(_id: string) {
    return this.http.get('branches/trashed/' + _id).map((response: Response) => response.json());
  }
  restoreTrashedById(_id: string) {
    return this.http.put('branches/trashed/' + _id,{}).map((response: Response) => response.json());
  }

  create(branch: Branch) {
    return this.http.post('branches', branch).map((response: Response) => response.json());
  }

  update(branch: Branch) {
    return this.http.put('branches/' + branch.id, branch).map((response: Response) => response.json());
  }

  delete(_id: string) {
    return this.http.delete('branches/' + _id).map((response: Response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/branches/branch.service.ts